import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class UserService {

    country: string;
    country$: BehaviorSubject<string> = new BehaviorSubject<string>('PL');

    constructor(private http: HttpClient) {


        this.http.get<{ country_code: string }>(environment.zortraxcom + '/ajax-api/geo_localization').subscribe(geo => {
                this.country = geo?.country_code ?? 'PL';

            }, err => {
                this.country = 'PL';

            }
        )

    }


}
